const SubscriptionStatus = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    TRIAL: 'TRIAL',
} as const;

export default SubscriptionStatus;
